import {
  dateRangeToMsg,
  gddRangeToMsg,
  calculateGdd,
  simpleAve,
} from "../../utils/helpers"
import { format } from "date-fns"

export default function CabbageMaggotLogic(data, dateOfInterest, modelData) {
  const { elements, dashboardDisplay, base } = modelData
  const { resultsTable, managementGuide } = elements
  const { generation, peakEmergence } = resultsTable

  const dailyDataWithGdd = calculateGdd(data.dailyData, base, 0, simpleAve)

  // Determine Management Guide Message ------------------------------------------------
  let managementGuideMsg = null
  let selectedDate = dailyDataWithGdd.find(
    (day) => day.dayOfYear === dateOfInterest.dayOfYear
  )
  if (!selectedDate) {
    selectedDate = dailyDataWithGdd.find((d) => d.isForecast)
  }

  if (selectedDate) {
    const msg = dateRangeToMsg(managementGuide.thresholds, dateOfInterest)
    if (msg) managementGuideMsg = msg
  }
  ///////////////////////////////////////////////////////////////////////////////////

  // Recalculating degree-days when wild grape bloom ----------------------------------
  const mData = dailyDataWithGdd.map((day) => {
    return {
      date: day.date,
      dateDisplay: format(day.date, "yyyy-MM-dd"),
      dayOfYear: day.dayOfYear,
      ms: day.ms,
      dd: day.dd,
      gdd: day.gdd,
      isForecast: day.isForecast,
      generation: gddRangeToMsg(generation, day.gdd),
      peakEmergenceStyle: gddRangeToMsg(peakEmergence, day.gdd),
      overwintering: null,
      springEmergence: null,
      first: null,
      second: null,
      third: null,
      fourth: null,
    }
  })
  // console.log(mData)
  ////////////////////////////////////////////////////////////////////////////////////

  // Data to display in Results Table --------------------------------------------------
  let tableData = [...mData]
  if (mData.length >= 8) {
    tableData = mData.slice(
      dateOfInterest.dayOfYear - 3,
      dateOfInterest.dayOfYear + 5
    )
  }
  // console.log(tableData)
  //////////////////////////////////////////////////////////////////////////////////////

  // Data in CSV format to export ------------------------------------------------------
  const csvData = mData.map((day) => {
    return {
      Date: format(day.date, "yyyy-MM-dd"),
      "Daily DD": day.dd,
      [dashboardDisplay]: day.gdd,
      Generation: day.generation,
    }
  })
  // console.log(csvData)
  /////////////////////////////////////////////////////////////////////////////////////

  // Dashboard summary ----------------------------------------------------------------
  let dashboard = { managementGuide: { dashboardDisplay: "" }, fromJan1: "" }

  const lastDate = mData.find((d) => d.isForecast)
  if (lastDate) {
    const msg = dateRangeToMsg(managementGuide.thresholds, lastDate)
    if (msg) {
      dashboard.managementGuide = msg
      dashboard.fromJan1 = lastDate.gdd
    }
  }

  return {
    data: mData,
    managementGuideMsg,
    dashboard,
    selectedDate,
    tableData,
    csvData,
  }
}
